import { useMemo } from 'react';
import memoizeOne from 'memoize-one';
import { useNavigationGlobalResource } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/navigation-global-resource/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import { findItemAndStack } from '../../common/utils/find-item-stack/index.tsx';
import { getLinks } from '../../common/utils/get-links/index.tsx';
import { transformLink } from '../../common/utils/transform-link/index.tsx';
import type { SearchResult } from './types.tsx';

// use memoised functions per hook to avoid re-computation between same hooks
const getItemsMemo = memoizeOne((d) =>
	getLinks(d, ['global-navigation-product'])
		.map(transformLink)
		.filter((item) => item != null && item.items),
);
const findItemAndStackMemo = memoizeOne(findItemAndStack);

export const useGlobalConnectItems = () => {
	const [{ route, location }] = useRouter();
	const { data, loading, error } = useNavigationGlobalResource();

	const sidebars = useMemo(() => data && getItemsMemo(data), [data]);

	const searchResult = useMemo<SearchResult>(() => {
		let result = { stack: [], selected: null, title: null, data: null };
		if (sidebars != null) {
			sidebars.some((sidebar) => {
				const { items } = sidebar || {};
				if (!sidebar || !route || items == null) return false;

				const found = findItemAndStackMemo(items, route.name, location);
				if (found) {
					// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
					result = { ...found, title: sidebar.name, data: items };
					return true;
				}
				return false;
			});
		}
		return result;
	}, [sidebars, route, location]);

	return { ...searchResult, loading, error };
};
